import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'as0011',
    ecrans: ['00-2']
});
